export enum DeliveryStatus {
    Pending,
    Delivered,
    Failed,
    Aborted
}

export class WebHookHistory {
    Id: string;
    OrganizationId: string;
    OrganizationName: string;
    DataSourceInstanceId: string;
    DataSourceInstanceName: string;
    Url: string;
    Status: DeliveryStatus;
    StatusReason: string;
    Payload: string;
    Attempts: number;
    CreatedUtc: Date | string;
    DeliveredUtc: Date | string;
    ResponseStatus: number;
}
